"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricerClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const Logger_1 = require("@deliverr/commons-logs/lib/Logger");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
class PricerClient extends base_client_1.ApiClient {
    constructor(config) {
        const PRICER_SERVICE_URL = config.baseURL || process.env.PRICER_SERVICE_URL;
        if (!PRICER_SERVICE_URL) {
            Logger_1.log.warn("PRICER_SERVICE_URL environment variable is not set");
        }
        let apiClientConfig = {
            authEngine: core_auth_1.AuthEngine.COGNITO,
        };
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            apiClientConfig = {
                authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL,
                tokenRefreshFn: tokenHandler.getTokenFn(),
            };
        }
        apiClientConfig = {
            ...config,
            ...apiClientConfig,
        };
        super({
            ...apiClientConfig,
            baseURL: `${PRICER_SERVICE_URL}`,
        });
    }
    async getUnitPrice(unitPriceRequest) {
        return this.post(`/pricer/getUnitPrice`, unitPriceRequest);
    }
    async getPackagePricesForOrder(getPackagePricesForOrderRequest) {
        return this.post(`/pricer/getPackagePricesForOrder`, getPackagePricesForOrderRequest);
    }
    async getItemizedPriceForItem(itemizedPriceForItemRequest) {
        return this.post(`/pricer/getItemizedPriceForItem`, itemizedPriceForItemRequest);
    }
    async getItemizedPriceForOrder(itemizedPriceForOrderRequest) {
        return this.post(`/pricer/getItemizedPriceForOrder`, itemizedPriceForOrderRequest);
    }
    async getItemizedPriceForOrderPerUnitDetail(itemizedPriceForOrderRequest) {
        return this.post(`/pricer/getItemizedPriceForOrderPerUnitDetail`, itemizedPriceForOrderRequest);
    }
    async getItemizedPriceForMultipleItems(itemizedPriceForMultipleItemsRequest) {
        return this.post(`/pricer/getItemizedPriceForMultipleItems`, itemizedPriceForMultipleItemsRequest);
    }
    async getItemizedPriceDetailsForMultipleItemGroups(itemizedPriceForMultipleItemGroupsRequest) {
        return this.post(`/pricer/getItemizedPriceDetailsForMultipleItemsGroups`, itemizedPriceForMultipleItemGroupsRequest);
    }
    async calculateSurcharges(calculateSurchargesRequest) {
        return this.post("/pricer/calculateSurcharges", calculateSurchargesRequest);
    }
    async calculateSurchargesPerPriceItem(calculateSurchargesPerPriceItemRequest) {
        return this.post("/pricer/calculateSurchargesPerPriceItem", calculateSurchargesPerPriceItemRequest);
    }
    async getProductTier(productTierRequest) {
        return this.post("/pricer/getProductTier", productTierRequest);
    }
    async getPackageWeight(packageWeightRequest) {
        return this.post("/pricer/getPackageWeight", packageWeightRequest);
    }
    async getRemovalPrice(removalPriceRequest) {
        return this.post(`/pricer/getRemovalPrice`, removalPriceRequest);
    }
    async getTotalRemovalPrice(totalRemovalPriceRequest) {
        return this.post(`/pricer/getTotalRemovalPrice`, totalRemovalPriceRequest);
    }
    async getTotalRemovalAndFulfillmentPrices(totalRemovalPriceRequest) {
        return this.post(`/pricer/getTotalRemovalAndFulfillmentPrices`, totalRemovalPriceRequest);
    }
    async getStoragePrice(storagePriceRequest) {
        return this.post(`/pricer/getStoragePrice`, storagePriceRequest);
    }
    async getRateSheet(referenceDate, destination, sellerId, isPackageBasedPricing = false) {
        return this.get(`/pricer/getRatesheet`, {
            referenceDate,
            destination,
            sellerId,
            isPackageBasedPricing,
        });
    }
    async getServiceLevelFromOrder(order) {
        return this.post(`/pricer/getServiceLevelFromOrder`, order);
    }
    async getServiceLevelFromOrders(orders) {
        return this.post(`/pricer/getServiceLevelFromOrders`, orders);
    }
    async assignDefaultPricing(defaultPricePlanAssignmentRequest) {
        return this.post(`/pricer/assignDefaultPricing`, defaultPricePlanAssignmentRequest);
    }
    async getStoragePriceV2(storagePriceRequest) {
        return this.post(`/pricer/v2/getStoragePrice`, storagePriceRequest);
    }
    async getServiceOfferingPricing(sellerId, referenceDate) {
        return this.get(`serviceOfferings/v1/serviceOfferingPricing`, {
            sellerId,
            referenceDate,
        });
    }
    async getItemizedRemovalPrice(removalsPriceRequest) {
        return this.post(`/pricer/v2/getItemizedRemovalPrice`, removalsPriceRequest);
    }
    async getCurrentAndUpcomingAccountPricePlanAssignments(sellerId, cutoffInDays, rateChangeNotificationRequired, referenceDate) {
        return this.get(`/pricePlan/v1/assignments`, {
            sellerId,
            cutoffInDays,
            rateChangeNotificationRequired,
            referenceDate,
        });
    }
    async createNonComplianceBaseRateCard(nonComplianceBaseRateCardRequest) {
        return this.post(`/non-compliance/v1/rate-card`, nonComplianceBaseRateCardRequest);
    }
    async createNonComplianceCustomRateCard(nonComplianceCustomRateCardRequest) {
        return this.post(`/non-compliance/v1/custom-rate-card`, nonComplianceCustomRateCardRequest);
    }
    async getNonComplianceRateCard(nonComplianceGetRateCardRequest) {
        return this.post(`/non-compliance/v1/get-rate-card`, nonComplianceGetRateCardRequest);
    }
    async updateNonComplianceRateCard(nonComplianceRateCardUpdateRequest) {
        return this.patch(`/non-compliance/v1/rate-card`, nonComplianceRateCardUpdateRequest);
    }
    async getBulkDiscountByDiscountId(getBulkDiscountRequest) {
        return this.post(`/discounts/v2/getBulkDiscount`, getBulkDiscountRequest);
    }
}
exports.PricerClient = PricerClient;
//# sourceMappingURL=PricerClient.js.map